const plain = x => x && typeof x === 'object' && !Array.isArray(x);
export function newState() {
  return {schema:2,activeCycle:'initial',cycles:[{id:'initial',label:'Текущая посадка'}],note:'',notes:{},checks:{},actionDates:{},observations:{},decisions:{},events:[],legacy:null};
}
export function validateState(x) {
  if(x?.notes!==undefined&&(!plain(x.notes)||!Object.values(x.notes).every(n=>typeof n==='string')))throw new Error('Invalid cycle notes');
  if (!plain(x) || x.schema !== 2 || typeof x.note !== 'string' || !Array.isArray(x.cycles) || !x.cycles.length || !x.cycles.every(c=>plain(c)&&typeof c.id==='string'&&typeof c.label==='string') || !x.cycles.some(c=>c.id===x.activeCycle) || !Array.isArray(x.events) || !x.events.every(e=>plain(e)&&typeof e.id==='string'&&typeof e.actionId==='string'&&typeof e.cycleId==='string'&&typeof e.at==='string') || !plain(x.checks) || !plain(x.observations) || !plain(x.decisions)) throw new Error('Invalid local guide data');
  return x;
}
function storageKey(manualId,mode){if(!['preview','public'].includes(mode))throw new Error('Invalid storage mode');return `uogorod-guide-v2-${mode==='preview'?'preview-':''}${manualId}`;}
export function loadState(storage, manualId,mode='preview') {
  const key=storageKey(manualId,mode), legacyKey=`uogorod-guide-v1-${manualId}`;
  const raw=storage.getItem(key);
  if(raw!==null) return validateState(JSON.parse(raw));
  const state=newState(), legacyRaw=storage.getItem(legacyKey);
  if(legacyRaw!==null) {
    const legacy=JSON.parse(legacyRaw);
    if(!plain(legacy)||typeof legacy.note!=='string'||!plain(legacy.checks)) throw new Error('Invalid legacy data');
    // Preserve the exact original BEFORE creating new state; never change the legacy key.
    const backup=`${key}-legacy-backup`;
    if(storage.getItem(backup)===null)storage.setItem(backup,legacyRaw);
    state.note=legacy.note; state.legacy={raw:legacyRaw,checks:legacy.checks};
  }
  storage.setItem(key,JSON.stringify(state));
  return validateState(JSON.parse(storage.getItem(key)));
}
export function persistState(storage, manualId, state,mode='preview') {
  validateState(state); storage.setItem(storageKey(manualId,mode),JSON.stringify(state));
}
export function addEvent(state, actionId, date, id, context, label) {
  if(!state.events.some(e=>e.id===id)) state.events.push({id,actionId,cycleId:state.activeCycle,at:date,context:{...context},...(label?{label}:{})});
}
export function addCycle(state,id,label) {
  if(!state.cycles.some(c=>c.id===id))state.cycles.push({id,label});
  state.activeCycle=id;
}
